/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
// import {
//   sleep
// } from "../core/utilities";

import {
  maybe,
  getWith
} from '../core/functions'

import {
  show,
  hide,
  dimBackground,
  removeBackground
} from '../functions/visibility'

import {
  makeType,
  parseOptions,
  initLog
} from '../core/base'

import Dispatcher, {
  Stream
} from '../core/dispatcher-flyd'

import {
  modelChanged
} from './common'

import VDOM from '../vdom/vdom'

import Request from '../core/request'
import UI from '../core/ui'

const closeEvent = elem =>
  elem.hasRole('popup-close')
    ? true
    : elem.parentElement.hasRole('popup-close')
      ? true
      : !!elem.hasClass('pop-background')

const openEvent = elem => elem.hasRole('popup-anchor')
const isActive = elem => elem.style.visibility === 'visible'

const proto = {
  name: 'Popup',
  injected: null,
  options: {
    transition: '0.3s ease-in-out',

    anchor: null,
    controlClass: 'scroll',

    onOpen: null,
    /* function to call on opening the popup */
    onClose: null
    /* function to call on closing the popup */
  },

  parseOptions,
  initLog,

  init() {
    return {
      active: false,
      show: false,
      originalUrl: window.location.pathname
    }
  },

  update(msg, model) {
    // this.log.warn(`msg:`, {
    //   ...msg
    // })
    model = {
      ...model
    }
    switch (msg.type) {
    case 'click':
      if (closeEvent(msg.target)) {
        model.show = false
        model.active = isActive(this.dom)
      }
      if (openEvent(msg.target)) {
        model.show = true
        model.active = isActive(this.dom)
      }

      break
    case 'keydown':
      if (
        isActive(this.dom) && [ 'Escape', 'esc' ].contains(msg.key)
      ) {
        event.preventDefault()
        event.stopPropagation()
        model.show = false
        model.active = isActive(this.dom)
        // this.log.warn(`original url: ${model.originalUrl}`)
        // console.log(`${window.location.origin}${model.originalUrl}`)
        if (model.originalUrl != null) {
          window.history.replaceState({}, '', `${window.location.origin}${model.originalUrl}`)
        }
      }

      break
    case 'popup-enabled':
      break

    case 'setURL':
      // this.log.warn(`setURL:`, {... msg})
      if (msg.record != undefined) {
        // this.log.warn(`settingoriginal url: ${msg.record} ${msg.record != null} ${msg.record != undefined}`)

        model.originalUrl = msg.record
      }
      break

    default:
      this.log.warn(`update: type: ${msg.type}`)
    }
    // this.log.warn(`updated model:`, {... model})
    return model
  },

  view(model) {
    // console.log(`view:`, {... model})
    model = {
      ...model
    }
    if (model.show === false && isActive(this.dom)) {
      this.hide()
      model.active = false
    }
    if (model.show === true && !isActive(this.dom)) {
      this.show()
      model.active = true
    }
    return model
  },

  initialize(dom) {
    this.dom = dom
    this.initLog()
    // this.log.warn('initializing popup')

    let currentModel = this.init()
    // this.log.warn(`initial model:`, {... currentModel})
    this.eventStream = new Stream()

    this.eventStream.map(msg => {
      let model = {
        ...currentModel
      }
      model = this.update(msg, model)
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      }
      currentModel = model
    })

    if (this.dom == null) {
      this.log.info('buildDOM:', this.buildDOM)
      this.buildDOM()
    }
    // this.log.warn(`uri: ${this.dom.dataset.uri}`)
    maybe(dom => {
      this.parseOptions()
      this.addControls()
      this.addAnchors()
      this.addKeyboardEvents()
      this.initializeSubclass()

      maybe(uri => this.getURL(uri))(getWith('uri')(dom.dataset))
    })(this.dom)
  },

  initializeSubclass() {},

  buildDOM() {
    this.log.info('buildDOM unimplemented: popup has no dom?')
  },

  buildDOM2() {
    const layout = {
      tag: 'div',
      dataset: {
        role: 'popup'
      },
      attrs: {
        class: 'vertical-horizontal-center hidden layer6 popup-window'
      },
      children: [ {
        tag: 'nav',
        dataset: {
          role: 'popup-close'
        },
        attrs: {
          class: 'corner-top-right'
        },
        children: [ {
          tag: 'button',
          attrs: {
            class: 'button button-close uibutton'
          }
        } ]
      } ]
    }

    const dom = VDOM.parseObject(layout)
    dom.render()
    return dom.findDOM()
  },

  addControls() {
    this.controls = this.dom.findByRole('popup-close')
    this.controls.forEach(t => {
      t.addEvent('click', this.eventStream.stream)
    })
  },

  addAnchors() {
    // show popup by clicking on an anchor or other element
    // const ctx = this
    document.findByRole('popup-anchor').forEach(a => {
      if (a.dataset.target === this.dom.dataset.id) {
        a.addEvent('click', this.eventStream.stream)
      }
    })
  },

  addKeyboardEvents() {
    document.addEvent('keydown', this.eventStream.stream)
  },

  show(cls) {
    show(this.dom, this.options.transition, cls)
    // const self = this

    if (cls) {
      this.addedClass = cls
    }
    if (this.options.onOpen) {
      this.options.onOpen()
    }

    dimBackground().addEvent('click', this.eventStream.stream)

    Dispatcher.dispatch({
      type: 'popup-enabled',
      record: this.dom
    })

    const frame = this.dom.getElement('iframe')
    if (frame && frame.contentWindow) {
      frame.contentWindow.focus()
      frame.contentWindow.addEvent('keydown', this.eventStream.stream)
    }
  },

  hide() {
    hide(this.dom, this.options.transition, this.addedClass)

    removeBackground()

    if (this.injected) {
      this.dom.removeChild(this.injected)
      this.injected = null
    }

    Dispatcher.dispatch({
      type: 'popup-disabled',
      record: this.dom
    })
  },

  loadReponse(response, onLoad, args) {
    // eslint-disable-next-line no-extra-semi
    ;
    [ ...this.dom.childNodes ]
      .filter(c => !this.controls.contains(c))
      .filter(c => c.dispose !== undefined)
      .forEach(c => {
        c.dispose()
      })

    const parent = document.createElement('div')
    parent.innerHTML = response

    // assume response has a single top-level element
    const injected = [ ...parent.childNodes ]
      .filter(n => n.nodeType === 1)
      .first()

    maybe(injected => {
      this.injected = injected
      this.dom.appendChild(this.injected)
      UI.evaluate(this.injected)
      if (onLoad) {
        onLoad(args)
      }
    })(injected)
  },

  setURL(url) {
    this.eventStream.stream({
      type: 'setURL',
      record: url
    })
  },

  getURL(url, onLoad, args) {
    const resolve = response => {
      if (response.startsWith('<!DOCTYPE html>')) {
        // TODO: show an error on popup
        this.hide()
      } else {
        this.loadReponse(response, onLoad, args)
      }
    }

    const reject = function (err) {
      this.log.error('getURL:', err)
    }

    Request.get(url).then(resolve, reject)
  }
}

const Popup = makeType(proto)
export default Popup

UI.register('popup', Popup)
